<template>
  <div class="content register-clock-page">
    <div class="row mt-0">
      <div class="col-12">
        <card>
          <div slot="header" class="register-header">
            <div>
              <h4 class="card-title text-left mb-1">Novo relógio</h4>
              <p class="register-subtitle mb-0">
                Informe os dados do equipamento e teste a conexão antes de
                cadastrar.
              </p>
            </div>
            <div class="step-indicator">
              <span :class="{ active: sinc_or_create === 'Testar conexão' }"
                >1</span
              >
              <i></i>
              <span :class="{ active: sinc_or_create === 'Cadastrar relógio' }"
                >2</span
              >
            </div>
          </div>

          <div class="register-form">
            <section class="form-section">
              <div class="section-title">
                <span><i class="tim-icons icon-tag"></i></span>
                <div>
                  <strong>Identificação</strong
                  ><small>Como o relógio será identificado no sistema</small>
                </div>
              </div>
              <div class="row">
                <base-input
                  name="nome"
                  class="col-md-6"
                  @input="resetForm()"
                  required
                  label="Nome do relógio"
                  placeholder="Ex.: Entrada principal"
                  v-model.trim="model.nome"
                  :class="{ 'has-danger': error.nome }"
                  :error="getError('nome')"
                />
                <div
                  class="col-md-6 form-group register-select-field"
                  :class="{ 'has-danger': error.modelo }"
                >
                  <label for="clock-model">Modelo do relógio *</label>
                  <el-select
                    id="clock-model"
                    name="modelo"
                    class="select-success register-select"
                    v-model="model.modelo"
                    placeholder="Selecione o modelo"
                    popper-class="clock-select-dropdown"
                    @change="resetForm()"
                  >
                    <el-option
                      class="select-success"
                      v-for="item in modelos"
                      :key="item.ID"
                      :label="item.Nome"
                      :value="item.Nome"
                    >
                      {{ item.Nome }}
                    </el-option>
                  </el-select>
                  <small v-if="error.modelo" class="select-error">
                    Selecione um modelo
                  </small>
                </div>
              </div>
            </section>

            <section class="form-section">
              <div class="section-title">
                <span><i class="tim-icons icon-bank"></i></span>
                <div>
                  <strong>Empresa</strong
                  ><small>Vincule o equipamento ao local correto</small>
                </div>
              </div>
              <div class="row">
                <base-input
                  name="empresa"
                  class="col-md-6"
                  @input="resetForm()"
                  required
                  label="Nome da empresa"
                  placeholder="Empresa responsável"
                  v-model.trim="model.empresa"
                  :class="{ 'has-danger': error.empresa }"
                  :error="getError('empresa')"
                />
                <div
                  class="col-md-6 form-group register-select-field"
                  :class="{ 'has-danger': error.empregador }"
                >
                  <label for="clock-employer">Posto da empresa *</label>
                  <el-select
                    id="clock-employer"
                    name="empregador"
                    class="select-success register-select"
                    v-model="model.id_empregador"
                    placeholder="Selecione o posto"
                    popper-class="clock-select-dropdown"
                    filterable
                    @change="resetForm()"
                  >
                    <el-option
                      v-for="item in listEmpregadores"
                      :key="item.id"
                      class="select-success"
                      :label="item.local"
                      :value="item.id"
                    >
                      {{ item.local }}
                    </el-option>
                  </el-select>
                  <small v-if="error.empregador" class="select-error">
                    Selecione um posto da empresa
                  </small>
                </div>
              </div>
            </section>

            <section class="form-section">
              <div class="section-title">
                <span><i class="tim-icons icon-wifi"></i></span>
                <div>
                  <strong>Conexão</strong
                  ><small
                    >Credenciais usadas para comunicação com o
                    equipamento</small
                  >
                </div>
              </div>
              <div class="row">
                <base-input
                  name="ip"
                  class="col-md-8"
                  required
                  @input="resetForm()"
                  label="Host / IP"
                  placeholder="Ex.: 192.168.0.100"
                  v-model="model.ip"
                  :class="{ 'has-danger': error.ip }"
                  :error="getError('ip')"
                />
                <base-input
                  name="porta"
                  class="col-md-4"
                  @input="resetForm()"
                  required
                  label="Porta"
                  placeholder="443"
                  v-model="model.porta"
                  :error="getError('porta')"
                  :class="{ 'has-danger': error.porta }"
                />
              </div>

              <div class="row">
                <base-input
                  name="usuario"
                  class="col-md-6"
                  @input="resetForm()"
                  required
                  label="Usuário de comunicação"
                  placeholder="admin"
                  v-model="model.usuario"
                  :error="getError('usuario')"
                  :class="{ 'has-danger': error.usuario }"
                />
                <base-input
                  name="senha"
                  class="col-md-6 password-input"
                  @input="resetForm()"
                  required
                  label="Senha de comunicação"
                  placeholder="admin"
                  :type="showPassword ? 'text' : 'password'"
                  v-model="model.senha"
                  :error="getError('senha')"
                  :class="{ 'has-danger': error.senha }"
                >
                  <button
                    slot="addonRight"
                    type="button"
                    class="password-toggle"
                    :aria-label="
                      showPassword ? 'Ocultar senha' : 'Mostrar senha'
                    "
                    @click="showPassword = !showPassword"
                  >
                    <i class="tim-icons icon-lock-circle"></i>
                    {{ showPassword ? "Ocultar" : "Mostrar" }}
                  </button>
                </base-input>
              </div>

              <div
                v-if="model.modelo && model.modelo !== 'Evo'"
                class="default-layout-info"
              >
                <i class="tim-icons icon-single-copy-04"></i>
                <div>
                  <strong>Layout padrão: Portaria 1510</strong>
                </div>
              </div>
            </section>
          </div>

          <div
            v-if="sinc_or_create === 'Cadastrar relógio'"
            class="connection-result"
          >
            <i class="tim-icons icon-check-2"></i>
            <div>
              <strong>Conexão realizada com sucesso</strong>
              <span>MAC: {{ responseSinc.resMac || "—" }}</span>
              <span>Serial: {{ responseSinc.resNSerie || "—" }}</span>
            </div>
          </div>

          <div class="register-actions">
            <base-button
              type="default"
              simple
              @click="$router.push('/controlId')"
            >
              Cancelar
            </base-button>
            <base-button
              type="success"
              @click="sincOrCreate()"
              :disabled="validateForm() || isLoading"
            >
              <i
                :class="
                  sinc_or_create === 'Testar conexão'
                    ? 'tim-icons icon-wifi'
                    : 'tim-icons icon-check-2'
                "
              ></i>
              {{ sinc_or_create }}
            </base-button>
          </div>
        </card>
      </div>
    </div>

    <div class="vld-parent">
      <loading
        :active="isLoading"
        :can-cancel="false"
        loader="spinner"
        color="#35a887"
        :is-full-page="true"
      />
    </div>
  </div>
</template>

<script>
import { Card, BaseInput } from "@/components/index";
import Loading from "vue-loading-overlay";
import swal from "sweetalert2";
const https = require("https");

const httpsAgent = new https.Agent({
  rejectUnauthorized: false
});

export default {
  components: {
    Loading,
    Card,
    BaseInput
  },
  data() {
    return {
      isLoading: false,
      showPassword: false,
      responseSinc: {
        resMac: "",
        resNSerie: "",
        session: ""
      },
      modelos: [
        { ID: "1", Nome: "REP IDClass (REP-C)" },
        { ID: "2", Nome: "IDClass 373 (REP-A)" },
        { ID: "3", Nome: "IDFace/ IDFlex (Coletor REP-P)" },
        { ID: "4", Nome: "Evo" },
        { ID: "5", Nome: "Outros" }
      ],
      listEmpregadores: [],
      sinc_or_create: "Testar conexão",
      file: null,
      model: {
        nome: "",
        id_empregador: "",
        empresa: "",
        modelo: "",
        ip: "",
        porta: "443",
        tipoAfd: "1510",
        usuario: "admin",
        senha: "admin",
        session: ""
      },
      error: {
        nome: false,
        empresa: false,
        modelo: false,
        ip: false,
        porta: false,
        usuario: false,
        senha: false,
        empregador: false,
        tipoAfd: false
      }
    };
  },

  mounted() {
    this.listarEmpregadores();
  },

  methods: {
    getError(fieldName) {
      return this.error[fieldName] ? `Erro no campo ${fieldName}` : "";
    },

    validateForm() {
      return (
        !this.model.nome ||
        !this.model.empresa ||
        !this.model.modelo ||
        !this.model.ip ||
        !this.model.porta ||
        !this.model.usuario ||
        !this.model.senha ||
        !this.model.id_empregador ||
        (this.model.modelo !== "Evo" && !this.model.tipoAfd)
      );
    },

    resetForm() {
      this.sinc_or_create = "Testar conexão";
      this.model.session = "";
      this.responseSinc.resMac = "";
      this.responseSinc.resNSerie = "";
      Object.keys(this.error).forEach(key => {
        this.error[key] = false;
      });
    },

    showSwal(type, title, text, typeMsg) {
      if (type === "auto-close") {
        swal({
          title,
          text,
          type: typeMsg,
          timer: 2000,
          showConfirmButton: false
        });
      }
    },

    async sincOrCreate() {
      if (this.sinc_or_create === "Testar conexão") {
        this.error.nome = !this.model.nome;
        this.error.empresa = !this.model.empresa;
        this.error.modelo = !this.model.modelo;
        this.error.ip = !this.model.ip;
        this.error.porta = !this.model.porta;
        this.error.usuario = !this.model.usuario;
        this.error.senha = !this.model.senha;
        this.error.empregador = !this.model.id_empregador;
        this.error.tipoAfd = this.model.modelo !== "Evo" && !this.model.tipoAfd;

        if (Object.values(this.error).some(error => error)) {
          this.showSwal(
            "auto-close",
            "Erro",
            "Preencha todos os campos obrigatórios!",
            "error"
          );
          return;
        }

        if (this.model.modelo === "IDFace/ IDFlex (Coletor REP-P)") {
          await this.loginIdFace();
        } else if (this.model.modelo === "Evo") {
          await this.loginEvo();
        } else {
          await this.loginLocal();
        }
      } else {
        await this.cadastrar();
      }
    },

    async loginIdFace() {
      this.isLoading = true;
      try {
        const form = {
          login: this.model.usuario,
          password: this.model.senha
        };
        const res = await this.axios.post(
          `https://${this.model.ip}:${this.model.porta}/login.fcgi`,
          form,
          { httpsAgent }
        );

        if (res.data.session) {
          this.model.session = res.data.session;
          await this.sincronizarFaceId();
        } else {
          throw new Error("O relógio não retornou uma sessão válida.");
        }
      } catch (err) {
        this.isLoading = false;
        this.showSwal(
          "auto-close",
          "Erro",
          "Erro ao sincronizar relógio!",
          "error"
        );
      }
    },

    async loginLocal() {
      this.isLoading = true;
      try {
        const form = {
          ip: this.model.ip,
          porta: this.model.porta,
          login: this.model.usuario,
          password: this.model.senha
        };
        const res = await this.axios.post(
          `https://${this.model.ip}/login.fcgi`,
          form,
          { httpsAgent }
        );

        if (res.data.session) {
          this.model.session = res.data.session;
          await this.sincronizarLocal();
        } else {
          throw new Error("O relógio não retornou uma sessão válida.");
        }
      } catch (err) {
        this.isLoading = false;
        this.showSwal(
          "auto-close",
          "Erro",
          "Erro ao sincronizar relógio!",
          "error"
        );
      }
    },

    async loginEvo() {
      this.isLoading = true;
      try {
        const res = await this.axios.post(
          `http://${this.model.ip}/api`,
          {
            password: this.model.senha,
            cmd: "reg"
          },
          {
            headers: {
              "Content-Type": "application/json",
              accept: "application/json, text/javascript, */*; q=0.01",
              "accept-language": "pt-BR,pt;q=0.9,en-US;q=0.8,en;q=0.7",
              "content-type": "application/json",
              "x-requested-with": "XMLHttpRequest",
              cookie:
                "lang=Brazilian; pwd=admin; deviceid=1; facesize=5000; fpsize=10000; firmware=ai518_fp70v_v2.02; elevator_control=0; floors=48; base_floor=0; have_g_floor=0; usequestion=1"
            },
            httpsAgent
          }
        );

        if (res.data.ret === "reg") {
          this.isLoading = false;
          this.sinc_or_create = "Cadastrar relógio";
          this.responseSinc.resMac = res.data.devinfo.mac;
          this.responseSinc.resNSerie = res.data.sn;
          this.showSwal(
            "auto-close",
            "Sucesso",
            "Relógio sincronizado com sucesso!",
            "success"
          );
        } else {
          throw new Error("Invalid response");
        }
      } catch (err) {
        this.isLoading = false;
        this.showSwal(
          "auto-close",
          "Erro",
          "Erro ao sincronizar relógio!",
          "error"
        );
      }
    },

    async sincronizarFaceId() {
      try {
        const res = await this.axios.post(
          `https://${this.model.ip}:${this.model.porta}/system_information.fcgi?session=${this.model.session}`,
          {},
          { httpsAgent }
        );

        this.isLoading = false;
        this.sinc_or_create = "Cadastrar relógio";
        this.responseSinc.resMac = res.data.network.mac;
        this.responseSinc.resNSerie = res.data.serial;
        this.showSwal(
          "auto-close",
          "Sucesso",
          "Relógio sincronizado com sucesso!",
          "success"
        );
      } catch (err) {
        this.isLoading = false;
        this.showSwal(
          "auto-close",
          "Erro",
          "Erro ao sincronizar relógio!",
          "error"
        );
      }
    },

    async sincronizarLocal() {
      try {
        const res = await this.axios.post(
          `https://${this.model.ip}/get_about.fcgi`,
          { session: this.model.session },
          { httpsAgent }
        );

        this.isLoading = false;
        this.sinc_or_create = "Cadastrar relógio";
        this.responseSinc.resMac = res.data.mac;
        this.responseSinc.resNSerie = res.data.nSerie;
        this.showSwal(
          "auto-close",
          "Sucesso",
          "Relógio sincronizado com sucesso!",
          "success"
        );
      } catch (err) {
        this.isLoading = false;
        this.showSwal(
          "auto-close",
          "Erro",
          "Erro ao sincronizar relógio!",
          "error"
        );
      }
    },

    async listarEmpregadores() {
      this.isLoading = true;
      try {
        const response = await this.axios.post(
          "/api/empregador/listarTodosEmpregadores2",
          {
            setDB: this.$cookies.get("db")
          }
        );
        this.listEmpregadores = response.data.data.dados;
      } catch (err) {
        this.showSwal(
          "auto-close",
          "Erro",
          "Erro ao listar empresas!",
          "error"
        );
      } finally {
        this.isLoading = false;
      }
    },

    async cadastrar() {
      this.isLoading = true;
      try {
        const form = {
          setDB: this.$cookies.get("db"),
          nome: this.model.nome,
          empresa: this.model.empresa,
          id_empregador: this.model.id_empregador,
          modelo: this.model.modelo,
          ip: this.model.ip,
          porta: this.model.porta,
          tipoAfd: this.model.modelo === "Evo" ? "" : this.model.tipoAfd,
          usuario: this.model.usuario,
          senha: this.model.senha,
          mac: this.responseSinc.resMac,
          nSerial: this.responseSinc.resNSerie,
          versionFW: "1",
          versionMRP: "1",
          session: this.model.session
        };

        const res = await this.axios.post(
          "/api/relogio/cadastrarRelogio",
          form
        );

        if (res.data.status === "success") {
          this.showSwal(
            "auto-close",
            "Sucesso",
            "Relógio cadastrado com sucesso! Aguarde a sincronização dos pontos!",
            "success"
          );
          await this.buscarArquivo();
          setTimeout(() => {
            this.$router.push("/controlId");
          }, 6000);
        } else {
          throw new Error("Erro ao cadastrar!");
        }
      } catch (err) {
        this.isLoading = false;
        this.showSwal("auto-close", "Erro", "Erro ao cadastrar!", "error");
      }
    },

    async buscarArquivo() {
      if (this.model.modelo === "IDFace/ IDFlex (Coletor REP-P)") {
        await this.buscarArquivoCompletoFaceID();
      } else if (this.model.modelo !== "Evo") {
        await this.buscarArquivoCompleto();
      }
    },

    async buscarArquivoCompletoFaceID() {
      try {
        const res = await this.axios.post(
          `https://${this.model.ip}:${this.model.porta}/export_afd.fcgi?session=${this.model.session}`,
          {},
          { httpsAgent }
        );
        this.file = res.data;
        await this.sincronizarArquivo();
      } catch (err) {
        this.isLoading = false;
        this.showSwal(
          "auto-close",
          "Erro",
          "Erro ao sincronizar com o relógio!",
          "error"
        );
      }
    },

    async buscarArquivoCompleto() {
      try {
        const form =
          this.model.tipoAfd === "671"
            ? { mode: Number(this.model.tipoAfd), session: this.model.session }
            : { session: this.model.session };

        const res = await this.axios.post(
          `https://${this.model.ip}/get_afd.fcgi`,
          form,
          { httpsAgent }
        );
        this.file = res.data;
        await this.sincronizarArquivo();
      } catch (err) {
        this.isLoading = false;
        this.showSwal(
          "auto-close",
          "Erro",
          "Erro ao sincronizar com o relógio!",
          "error"
        );
      }
    },

    async sincronizarArquivo() {
      try {
        const form = {
          setDB: this.$cookies.get("db"),
          id_empregador: this.model.id_empregador,
          file: this.file,
          modelo: this.model.modelo
        };

        const res = await this.axios.post(
          "/api/sincronizando/pontosCompleto",
          form
        );

        if (res.data.status === "success") {
          this.showSwal(
            "auto-close",
            "Sucesso",
            "Relógio cadastrado com sucesso!",
            "success"
          );
        } else {
          this.showSwal("auto-close", "Erro", res.data.err, "error");
        }
      } catch (err) {
        this.showSwal(
          "auto-close",
          "Erro",
          "Ocorreu algum erro ao sincronizar os pontos por arquivo!",
          "error"
        );
      } finally {
        this.isLoading = false;
      }
    }
  }
};
</script>

<style scoped>
.register-clock-page .register-header,
.register-clock-page .section-title,
.register-clock-page .register-actions,
.register-clock-page .connection-result,
.register-clock-page .step-indicator {
  display: flex;
  align-items: center;
}
.register-clock-page .register-header {
  justify-content: space-between;
  gap: 20px;
}
.register-clock-page .register-subtitle {
  color: #8f9bb3;
  font-size: 13px;
}
.register-clock-page .step-indicator span {
  display: inline-flex;
  width: 28px;
  height: 28px;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 50%;
  color: #8f9bb3;
  font-size: 11px;
  font-weight: 600;
}
.register-clock-page .step-indicator span.active {
  border-color: #35a887;
  background: rgba(53, 168, 135, 0.14);
  color: #35a887;
}
.register-clock-page .step-indicator i {
  width: 28px;
  height: 1px;
  background: rgba(255, 255, 255, 0.14);
}
.register-clock-page .register-form {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}
.register-clock-page .form-section {
  min-width: 0;
  padding: 20px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.02);
}
.register-clock-page .form-section:last-child {
  grid-column: 1 / -1;
}
.register-clock-page .section-title {
  gap: 11px;
  margin-bottom: 19px;
}
.register-clock-page .section-title > span {
  display: inline-flex;
  width: 34px;
  height: 34px;
  flex: 0 0 34px;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  background: rgba(53, 168, 135, 0.12);
  color: #35a887;
}
.register-clock-page .section-title strong,
.register-clock-page .section-title small {
  display: block;
}
.register-clock-page .section-title small {
  margin-top: 2px;
  color: #8f9bb3;
  font-size: 10px;
}
.register-clock-page .register-select-field > label {
  display: block;
  margin-bottom: 5px;
  color: #9a9a9a;
  font-size: 0.75rem;
}
.register-clock-page .register-select {
  width: 100%;
}
.register-clock-page .select-error {
  display: block;
  margin-top: 5px;
  color: #ec250d;
  font-size: 0.75rem;
}
.register-clock-page .default-layout-info {
  display: flex;
  align-items: flex-start;
  gap: 11px;
  padding: 12px 14px;
  border-radius: 9px;
  background: rgba(53, 168, 135, 0.09);
  color: #35a887;
}
.register-clock-page .default-layout-info i {
  margin-top: 3px;
}
.register-clock-page .default-layout-info strong,
.register-clock-page .default-layout-info small {
  display: block;
}
.register-clock-page .default-layout-info small {
  margin-top: 3px;
  color: #8f9bb3;
  font-size: 10px;
}
.register-clock-page .password-toggle {
  height: 38px;
  padding: 0 11px;
  border: 1px solid #2b3553;
  border-left: 0;
  border-radius: 0 0.4285rem 0.4285rem 0;
  background: transparent;
  color: #8f9bb3;
  cursor: pointer;
  font-size: 10px;
}
.register-clock-page .password-toggle i {
  margin-right: 4px;
}
.register-clock-page .connection-result {
  gap: 12px;
  margin-top: 16px;
  padding: 14px 18px;
  border: 1px solid rgba(53, 168, 135, 0.22);
  border-radius: 10px;
  background: rgba(53, 168, 135, 0.08);
}
.register-clock-page .connection-result > i {
  display: inline-flex;
  width: 34px;
  height: 34px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #35a887;
  color: white;
}
.register-clock-page .connection-result strong {
  display: block;
  color: #35a887;
  font-size: 12px;
}
.register-clock-page .connection-result span {
  display: inline-block;
  margin-top: 3px;
  margin-right: 18px;
  color: #c8ceda;
  font-size: 10px;
}
.register-clock-page .register-actions {
  justify-content: flex-end;
  gap: 9px;
  margin-top: 20px;
}
.register-clock-page .register-actions i {
  margin-right: 6px;
}
@media (max-width: 767px) {
  .register-clock-page .register-header {
    align-items: flex-start;
  }
  .register-clock-page .register-form {
    grid-template-columns: 1fr;
  }
  .register-clock-page .form-section:last-child {
    grid-column: auto;
  }
  .register-clock-page .form-section {
    padding: 16px;
  }
  .register-clock-page .register-actions {
    flex-direction: column-reverse;
  }
  .register-clock-page .register-actions .btn {
    width: 100%;
  }
}
</style>

<style>
.clock-select-dropdown {
  max-width: calc(100vw - 30px);
}
.clock-select-dropdown .el-select-dropdown__item {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
